import { IInfrastructureType } from '../../../common/types/infrastructure';
import { IMapState } from '../../types';

export function selectTypes(state: IMapState): IInfrastructureType[] {
  return Object.values(state.map.infrastructure.types);
}
